function deferFilterjQuery() {
  if (window.jQuery) { 
      $(function(){
        // On load/reload
        var pt_on_load = function() {
          // Accordion            
            
            $('.filter-menu .filter-group').not('.has_group_selected, .refine-header, .refine-header, .pt-display-dropdown').first().toggleClass('pt-group-expanded');
            
          

          // Search
          $('.pt-display-search').not('.has_group_selected').find('input.fm-search-box').show();

          // Drop downs
          $('.pt-display-dropdown').each(function( index ) {
              $(this).find('h4').after($(this).find('.filter-clear'));
          });

          $('.pt-display-dropdown .scroll-content').each(function( index ) {
              if($(this).find('li.selected').length) {
                  var selected = $.map(
                      $(this).find('li.selected a'),
                          function(element){
                              return $(element).text();
                          }
                    ).join(", ");

                if (selected.length < 30) {
                  $(this).before('<div class="menu-trigger">' + selected +'</div>');
                } else {
                   $(this).before('<div class="menu-trigger">' + $(this).find('li.selected').length + ' Selected </div>');
                }
              }
              else {
                  $(this).before('<div class="menu-trigger">'+ $(this).closest('.filter-group').find('h4').text() +'</div>');
              }
          });

          // View more
          

          $('.filter-menu li a').attr('title', function() {
            return ($(this).closest('li').hasClass('selected') ? "Clear filter: " : "Add filter: ") + $(this).text();
          });
        }

        pt_on_load();

        // Mobile filter button
        

        // Accordion
        
        $(document).on('click', '.filter-menu h4', function(e){
          $(this).closest('.filter-group').not('.has_group_selected, .refine-header, .pt-display-dropdown').toggleClass('pt-group-expanded');
          e.preventDefault();
        });
        

        // Search
        $(document).on('keyup', '.filter-group input.fm-search-box', function () {
          var value = this.value.toLowerCase();
          $(this).closest('.filter-group').find('li').each(function () {
            if ($(this).text().toLowerCase().search(value) > -1) {
              $(this).show(100);
            } else {
              $(this).hide(100);
            }
          });
        });

        // Drop downs
        $(document).on('click','.pt-display-dropdown .menu-trigger',function() {
          $(this).next('.scroll-content').css('top', $(this).position().top + $(this).height() + 1).css('left', $(this).position().left);
          $(this).next('.scroll-content').slideToggle('fast');
        });

        $(document).on('mouseleave', '.pt-display-dropdown .scroll-content', function() {
          $(this).slideUp('fast');
        });

        // Apply button
        

        // Ajax
        
        $.getScript("//cdn.shopify.com/s/files/1/0012/1661/0359/t/5/assets/jquery.pjax.js?5169").done(function(script, textStatus) {
          $body = $("body");
          $(document).pjax('#main .filter-group a, #main .pagination a', '#main', { fragment: '#main', timeout: 10000, scrollTo: false, push: true });
          $(document).on('pjax:start', function(){  $body.addClass("pt-ajax-loading"); $('#main').fadeTo('slow', 0.8); })
          $(document).on('pjax:end', function(){ $body.removeClass("pt-ajax-loading"); $('#main').fadeTo('fast', 1); pt_on_load(); ; });
        });
        
    });
  }
  else {
    setTimeout(function() { deferFilterjQuery() }, 50);
  }
}

deferFilterjQuery();


/* Custom Filter Mobile */
if (window.outerWidth < 768) {

  //Jquery de filtro mobile
  $(document).on('click', '#bc-sf-filter-tree-mobile-button', function() {
    $('.headerModal').removeClass('d-none');
    $('.footerModal').removeClass('d-none');
    $('#cerrarFiltroMobilePad').show();
    $(".noUi-handle").attr("ontouchend","touchEndMobileFilter()");
    $(".bc-sf-filter-option-range-amount-min").attr('disabled', true);
    $(".bc-sf-filter-option-range-amount-max").attr('disabled', true);
    mostarItemOcultarsubitem();
  });

  //oculta el header,  footer y modal del filtro mobile
  function limpiarModalFiltro() {
    $('#bc-sf-filter-tree').hide();
    $('.headerModal').addClass('d-none');
    $('.footerModal').addClass('d-none');
    $('#cerrarFiltroMobilePad').hide();
    mostarItemOcultarsubitem();
    contarTotal();
    contarPorItem();
  }

  //oculta la item que no se estan usando
  function hideItemNoUse() {
    $('.bc-sf-filter-block-content').hide();
    $('.bc-sf-filter-block-title').hide(); 
    $("#bc-sf-filter-options-wrapper .bc-sf-filter-option-block").css("border-bottom-color", "#fff");
    $('#bc-sf-filter-options-wrapper .bc-sf-filter-block-title h3').attr("aria-expanded", "false");
    $('#bc-sf-filter-options-wrapper .bc-sf-filter-block-title h3').children('span').addClass("up");
    $('.bc-sf-filter-option-block').css("padding-top", "0px");
    $('.modalFilter .bc-sf-filter-option-block').css("padding", "0px 10px");
    $(".noUi-handle").attr("ontouchend","touchEndMobileFilter()");
    $(".bc-sf-filter-option-range-amount-min").attr('disabled', true);
    $(".bc-sf-filter-option-range-amount-max").attr('disabled', true);
  }

  //Muestra los Item padre y oculta lo Item hijo
  function mostarItemOcultarsubitem() {
      $('#title-filtrar-custom').text("FILTRAR");
       $('#title-filtrar-custom').css("font-size", "17px"); 
      $('#arrow-filter-mobile').hide();
      $('.bc-sf-filter-block-title').show(); 
      $("#bc-sf-filter-options-wrapper .bc-sf-filter-option-block").css({"border-bottom": "1px solid #e3e3e3","border-bottom-color":"#ccc"});
      $('.bc-sf-filter-block-content').hide();
      $('.bc-sf-filter-option-block').css("padding-top", "20px");
      $('.bc-sf-filter-option-block').css("padding", "20px 10px");
      $('#bc-sf-filter-options-wrapper .bc-sf-filter-block-title h3 span').addClass("up");

  }
  

  //contador total
  function contarTotal() {
    let total = $('#bc-sf-filter-options-wrapper .selected').length;
    
    let isCounterFilterCustom = $( "#bc-sf-filter-tree-mobile-button span" ).hasClass( "counterFilterCustom" );
     
    if(total>0 && !isCounterFilterCustom) {

      $('#bc-sf-filter-tree-mobile-button').append('<span class="counterFilterCustom">'+total+'</span>');
    }

  }

    //contador total
  function contarPorItem() {
    //let recorrer = $('.bc-sf-filter-block-content').each();
      $(".bc-sf-filter-block-content").each(function(){
          let  idItems = $(this).attr('id');
          let total = $('#'+idItems+' .selected').length;
        
          
          if(total>0) {
            $('#'+idItems).siblings('.bc-sf-filter-block-title').children('h3').after('<span class="counterFilterCustomItem">'+total+'</span>');
            
          }
        
        });
      
    
      
  }


  //click en el Item padre
  $(document).on('click','#bc-sf-filter-options-wrapper .bc-sf-filter-block-title h3',function() {

      let textFiltro = $(this).attr("aria-label").replaceAll("-", " ");
      let nombreBlock = $(this).attr("aria-label");
      if(nombreBlock== "descuento"){
        $('#bc-sf-filter-option-block-descuento ul li a').show();
      }

      //Hace que las colletions redireccionen a otras páginas
      if($(".modalFilter .bc-sf-filter-block-content ul" ).hasClass( "bc-sf-filter-option-single-list")) {
        $(".modalFilter ul.bc-sf-filter-option-single-list li a").each(function() {
          $(this).attr("onclick", "$(location).attr('href',this.href);");
      });
    }

    
      $('#title-filtrar-custom').text(textFiltro);
      $('#arrow-filter-mobile').show();
      $('.bc-sf-filter-block-title').hide();   
      $("#bc-sf-filter-options-wrapper .bc-sf-filter-option-block").css("border-bottom-color", "#fff");
      $(this).attr("aria-expanded", "false");
      $(this).children('span').addClass("up");
      $('.bc-sf-filter-option-block').css("padding-top", "0px");
      $('.modalFilter .bc-sf-filter-option-block').css("padding", "0px 10px");
      let contarCaractHeader = $("#title-filtrar-custom").text().length;
      if(contarCaractHeader > 15){
        $('#title-filtrar-custom').css("font-size", "10px");
      }else {
        $('#title-filtrar-custom').css("font-size", "17px"); 
      }
      $(".noUi-handle").attr("ontouchend","touchEndMobileFilter()");
  });               
        

      
  //click en eñ subitem, genera el reaload
  $(document).on('click','#bc-sf-filter-options-wrapper .bc-sf-filter-block-content',function() {
    
  let content = $(this).attr("id");	
      let compDesc = $(this).siblings('div.bc-sf-filter-block-title').children("h3").text();
      
    
   
    //loading
        $('#'+content).after('<div class="loadingfilterCustom"><span></span></div>');
        $('#arrow-filter-mobile').parent().addClass('desctivflecha');
    
          hideItemNoUse();
        $('#'+content).css("display", "block");
    
          for(i=5; i<=20; i++ ) {
            setTimeout(function(){ 		
                    hideItemNoUse();
                    $('#'+content).css("display", "block");

            }, i*100);

          }	      

    setTimeout(function(){ 		
            $('.loadingfilterCustom').remove();
            $('#arrow-filter-mobile').parent().removeClass('desctivflecha');
            if(compDesc == "Descuento"){
              $('#bc-sf-filter-option-block-descuento ul li a').show();
            }
          }, 2010);

  });

  function touchEndMobileFilter(a) {
        //loading
        $('#bc-sf-filter-option-block-precio').after('<div class="loadingfilterCustom"><span></span></div>');
        $('#arrow-filter-mobile').parent().addClass('desctivflecha');
    
          hideItemNoUse();
        $('#bc-sf-filter-option-block-precio').css("display", "block");
    
          for(i=5; i<=20; i++ ) {
            setTimeout(function(){ 		
                    hideItemNoUse();
                    $('#bc-sf-filter-option-block-precio').css("display", "block");

            }, i*100);

          }	      

    setTimeout(function(){ 		
            $('.loadingfilterCustom').remove();
            $('#arrow-filter-mobile').parent().removeClass('desctivflecha');
          }, 2010);
  }


  //al hacer click en la flecha del filtro
  $(document).on('click','#arrow-filter-mobile',function() {
      mostarItemOcultarsubitem();
      contarTotal();
    contarPorItem();
  });

  //al hacer click en la x
  $(document).on('click','#x-filtrar',function() {
      mostarItemOcultarsubitem();
      contarTotal();
      contarPorItem();
  });
  
  //contador total al recargar
  $(window).on("load", contarTotal);

  //contador por item
  $(window).on("load", contarPorItem);

  //mostar filtro ordenar
  $(window).on("load", mostrarOrdenar);
  function mostrarOrdenar() {
    setTimeout(function(){ 
      $('#bc-sf-filter-top-sorting-mobile').show();
    }, 100);  
  }


}




